import { v4 as uuidv4 } from 'uuid';
import { extractTitleFromUrl, extractTypeFromLayerId } from "./util"
import { zoomToSource } from "./addPMTilelayers";

export const defaultGeoTiffLayerOptions = {
  'paint': {
    'raster-opacity': 0.8,
    'raster-brightness-min': 0,
    'raster-brightness-max': 1,
    'raster-contrast': 0,
  },
  'layout': {
    'visibility': 'visible'
  }
};

export const addGeoTiffLayer = async (
  map, sourceParams, prefix = 'fic',
  existingLayerId = null, existingSourceId = null,
  zoomTo = false, catalogId, layerIdFromBookmark) => {
  try {
    const cogBaseEndPoint = 'https://ou60yuvp0i.execute-api.us-east-1.amazonaws.com/cog';
    const uuid = uuidv4();
    const sourceId = existingSourceId || `s-${uuid}`;
    const layerId = layerIdFromBookmark || existingLayerId || `l-${prefix}-${uuid}`;

    const url_params = createParamString(sourceParams);
    const url = sourceParams['url'];
    const endpoint = `${cogBaseEndPoint}/info?${url_params}`;

    const fetchmeta = async () => {
      const res = await fetch(endpoint);
      const data = await res.json();
      if (map.getLayer(layerId)) map.removeLayer(layerId);
      if (map.getSource(sourceId)) map.removeSource(sourceId);

      map.addSource(
        sourceId, {
        'type': 'raster',
        'tiles': [`${cogBaseEndPoint}/tiles/{z}/{x}/{y}@1x.png?${url_params}`],
        'minzoom': 13,
        'maxzoom': 22,
        'tileSize': 256,
        'bounds': data.bounds,
      });

      map.addLayer({
        'id': layerId,
        'type': 'raster',
        'source': sourceId,
        ...defaultGeoTiffLayerOptions
      }, "gl-draw-line.cold");
      if (zoomTo === true) {
        zoomToSource(map, map.getSource(sourceId));
      }
      return data
    }
    const meta = await fetchmeta();
    return {
      sourceId: sourceId,
      id: layerId,
      assetUrl: url,
      assetType: extractTypeFromLayerId(layerId),
      title: extractTitleFromUrl(url),
      catalogId: catalogId,
      meta: meta
    }
  } catch (err) {
    console.error("Error occurred adding a GeoTiff layer.");
    return null;
  }
}

const createParamString = (obj) => {
  return Object.keys(obj)
    .map(key => `${key}=${obj[key]}`)
    .join('&');
}

